
<!-- Wait until MSAL finishes initialization -->
<ng-container *ngIf="authStateService.isReady">

  <!-- Not authenticated -->
  <div *ngIf="!authStateService.isAuthenticated" class="hero-section">
    <h1 class="hero-heading"> xPetro Systems </h1>
  </div>

  <!-- Authenticated -->
  <app-dashboard
    *ngIf="authStateService.isAuthenticated">
  </app-dashboard>

</ng-container>




